<template>
    <div class="book-later">
        <checker-detail-row>
            <h5>Arriving At</h5>
            <div class="form-groups">
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <datepicker
                        id="start_date"
                        :options="startDateConfig"
                        v-model="start_date"
                        class="datepicker form-control v2-styles dropdown-arrow"
                        name="start_date"
                    />
                </div>
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <timepicker
                        id="start_time"
                        :options="startTimeConfig"
                        v-model="start_time"
                        class="timepicker form-control v2-styles dropdown-arrow"
                        name="start_time"
                    />
                </div>
            </div>
        </checker-detail-row>
        <checker-detail-row>
            <h5>Departing At</h5>
            <div class="form-groups">
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <datepicker
                        id="end_date"
                        :options="endDateConfig"
                        v-model="end_date"
                        class="datepicker form-control v2-styles dropdown-arrow"
                        name="start_date"
                    />
                </div>
                <div class="form-group">
                    <div class="input-chevron-icon"/>
                    <timepicker
                        id="end_time"
                        :options="endTimeConfig"
                        v-model="end_time"
                        class="timepicker form-control v2-styles dropdown-arrow"
                        name="start_time"
                    />
                </div>
            </div>
        </checker-detail-row>
    </div>
</template>

<script>
    import SaneDates from '../../../mixins/SaneDates';
    import Timepicker from '../../../forms/Timepicker';
    import Datepicker from '../../../forms/Datepicker';
    import CheckerDetailRow from '../CheckerDetailRow';
    import BaseDateTimeInput from '../BaseDateTimeInput';
    import storeFormSync from '../../../../store/form-sync';
    import { mapReducers } from 'assets/js/modules/reducer';
    import moment from 'moment';

    export default {
        name: 'book-later',

        components: { CheckerDetailRow, Datepicker, Timepicker },

        mixins: [SaneDates, BaseDateTimeInput],

        computed: {
            ...storeFormSync([
                'booking.reservation_details.bookings[0].start_date',
                'booking.reservation_details.bookings[0].start_time',
                'booking.reservation_details.bookings[0].end_date',
                'booking.reservation_details.bookings[0].end_time',
                'booking.reservation_details.bookings[0].quote',
            ]),

            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'booking_type',
            ]),
        },

        watch: {
            start_time(val) {
                if (this.end_date === this.start_date && val >= this.end_time) {
                    this.end_date = this.endDateConfig.minDate;
                    this.end_time = moment(val, 'HH:mm').add(2, 'hours').format('HH:mm');
                }
            },

            start_date(val) {
                if (this.end_date < this.start_date) {
                    this.end_date = val;
                    this.end_time = moment(this.start_time, 'HH:mm').add(2, 'hours').format('HH:mm');
                }
            },

            end_time(val) {
                if (this.end_date === this.start_date && val <= this.start_time) {
                    this.start_date = this.end_date;
                    this.start_time = moment(val, 'HH:mm').subtract(2, 'hours').format('HH:mm');
                }
            },

            end_date(val) {
                if (val <= this.start_date) {
                    this.start_date = val;

                    if (this.end_time < this.start_time) {
                        this.start_time = moment(this.end_time, 'HH:mm').subtract(2, 'hours').format('HH:mm');
                    }
                }
            },
        },
    };
</script>

<style lang="less">
    .book-later .checker-detail-row.checker-detail-row {
        padding: 0 0 5px;
        border-bottom: 0;
    }
</style>
